module.exports = __webpack_public_path__ + "static/media/icon-wheelchair.d689445f.svg";